<div class="modal-container">
	<!-- Modal Header -->
	<div class="modal-header">
		<h2 class="modal-title">
			<mat-icon>settings</mat-icon>
			<span>{{'telaPreferenciasUsuario.preferenciasUsuario' | translate}}</span>
		</h2>
		<button class="close-button" (click)="fechar()" mat-icon-button>
			<mat-icon>close</mat-icon>
		</button>
	</div>

	<!-- Modal Content -->
	<div class="modal-content">
		<div class="preferences-section" *ngIf="preferencias.exibirTrocaConta">
			<h3 class="section-title">
				<mat-icon>bookmark</mat-icon>
				{{'telaPreferenciasUsuario.contaPerfil' | translate}}
			</h3>
			<div class="preferences-controls">
				<div class="preference-field">
					<label for="select-carteira">
						Alternar entre contas 
					</label>
					<ng-select id="select-conta" [clearable]="false" [(ngModel)]="hashConta" bindValue="value"
						bindLabel="label" (change)="clienteChange()" [items]="contas" appendTo="body">
					</ng-select>
				</div>
			</div>
		</div>
		<div class="preferences-section">
			<h3 class="section-title">
				<mat-icon>bookmark</mat-icon>
				{{'telaPreferenciasUsuario.camposPreSelecionados' | translate}}
			</h3>

			<div class="preferences-controls">
				<div class="preference-field">
					<label for="select-carteira">
						{{'telaPreferenciasUsuario.carteira' | translate}} 
					</label>
					<ng-select id="select-carteira" [clearable]="true" [(ngModel)]="preferencias.carteiraId"
						bindValue="carteiraId" bindLabel="nome" (change)="carteiraChange($event)" [items]="carteiras"
						appendTo="body">
					</ng-select>
				</div>

				<div class="preference-field">
					<label for="select-lista">
						{{'telaPreferenciasUsuario.lista' | translate}}
					</label>
					<ng-select id="select-lista" [clearable]="true" [(ngModel)]="preferencias.listaId"
						[disabled]="existePreferenciaCarteira == false" bindValue="listaId" bindLabel="nome"
						[items]="listas" appendTo="body">
					</ng-select>
				</div>
			</div>
		</div>
	</div>

	<!-- Modal Footer -->
	<div class="modal-footer">
		<div class="footer-left">
			<button (click)="fechar()" mat-raised-button>
				<mat-icon>close</mat-icon>
				{{'telaPadrao.fechar' | translate}}
			</button>
		</div>
		<div class="footer-right">
			<button (click)="gravar()" color="primary" mat-raised-button>
				<mat-icon>save</mat-icon>
				{{'telaPadrao.gravar' | translate}}
			</button>
		</div>
	</div>
</div>